import { LocationTypes } from '../../constants';
import { HourStatus, LocationType } from './location.types';

export const WEEK_HOURS_DAYS = [1, 2, 3, 4, 5, 6, 0] as const; // Monday to Sunday

export const CLOSING_SOON_THRESHOLD_SECONDS = 3600; // 1 hour

export const LEGACY_LOCATION_TYPE_TO_TRANS_KEY: Record<
  'evac_shelter' | 'animal_shelter' | 'info' | 'general' | 'food',
  string
> = {
  [LocationTypes.evacShelter]: 'location.types.shelter',
  [LocationTypes.animalShelter]: 'location.types.animalShelter',
  [LocationTypes.info]: 'location.types.info',
  [LocationTypes.general]: 'location.types.general',
  [LocationTypes.food]: 'location.types.food',
};

export const LOCATION_TYPE_TO_TRANS_KEY: Record<LocationType, string> = {
  [LocationTypes.shelter]: 'location.types.shelter',
  [LocationTypes.evacShelter]: 'location.types.evacShelter',
  [LocationTypes.animalShelter]: 'location.types.smallAnimalShelter', // for backward compatibility
  [LocationTypes.smallAnimalShelter]: 'location.types.smallAnimalShelter',
  [LocationTypes.info]: 'location.types.info',
  [LocationTypes.general]: 'location.types.general',
  [LocationTypes.food]: 'location.types.meals', // for backward compatibility
  [LocationTypes.meals]: 'location.types.meals',
  [LocationTypes.firstAid]: 'location.types.firstAid',
  [LocationTypes.temporaryEvacPoint]: 'location.types.temporaryEvacPoint',
  [LocationTypes.sandBags]: 'location.types.sandBags',
  [LocationTypes.water]: 'location.types.water',
  [LocationTypes.farmersMarket]: 'location.types.farmersMarket',
  [LocationTypes.foodPantry]: 'location.types.foodPantry',
  [LocationTypes.largeAnimalShelter]: 'location.types.largeAnimalShelter',
  [LocationTypes.maskDistribution]: 'location.types.maskDistribution',
  [LocationTypes.communityDistribution]: 'location.types.communityDistribution',
};

// Resolves the translation key for a location type, falling back to the generic "General" label so older clients
// will fail gracefully. Mirrors the `|| GeneralLocation` fallback in `getLocationIcon`.
export const getLocationTypeTransKey = (
  locationType: LocationType,
  showLocationV2: boolean,
): string => {
  const transKeys: Record<string, string> = showLocationV2
    ? LOCATION_TYPE_TO_TRANS_KEY
    : LEGACY_LOCATION_TYPE_TO_TRANS_KEY;
  return (
    transKeys[locationType] ?? LOCATION_TYPE_TO_TRANS_KEY[LocationTypes.general]
  );
};

export const LOCATION_HOURS_STATUS_TO_TRANS_KEY: Record<HourStatus, string> = {
  open: 'location.hourStatus.open',
  closed: 'location.hourStatus.closed',
  closingSoon: 'location.hourStatus.closingSoon',
};
